import React from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import "./styles/toast.css";

const App = () => {
  return <Routes />;
};

export default App;
